import React from 'react';
import Moment from 'react-moment';
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { Link } from 'react-router-dom';
import { getURL, isValidDate } from 'helpers/utils';
import { List } from 'components/general/List';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



export default function ComponentDays({ daysItems }) {
    let _daysItems = daysItems;
    const postList = _daysItems?.competition_schedule ? (
        <>
            {/* <DaysList items={daysItems.competition_schedule} />*/}
            < List
                items={_daysItems.competition_schedule}
                resourceName="day"
                itemComponent={DayItem}
            />

        </>
    ) : (
        <div>No data</div>
    )
    return (
        <div className={"d-flex flex-wrap DayContainer"}>
            <DayItem day='All days' />{postList}
        </div>
    )
}



export function DayItem({ day }) {
    const globalProps = useSelector(getGlobalProps)

    let params = useUrlFriendlyToParameters();
    //Copy object in order to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   (Change URL object)

    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    if (paramsURL['mirs_discipline'] === undefined) {
        paramsURL['mirs_discipline'] = process.env.REACT_APP_DEFAULT_DISCIPLINE
    }


    //alert(paramsURL['mirs_event'])
    const _date = paramsURL["mirs_date"] //Date from url 

    let date = "";
    if (isValidDate(day.date)) {
        date = day.date;
    }
    paramsURL["mirs_date"] = date //pasamos a la URL la nueva fecha del JSON 

    const url = getURL(paramsURL, 'schedule')


    if (date === "") {
        return (
            <div className={`DayBox  ${(_date === date) ? "active" : ""}`} valuedate={date}  >
                <Link to={url}>
                    <div className={`text-center  DayBigFont`}>
                        All
                    </div>
                    <div className={`text-center  DaySmallFont`} >
                        days
                    </div>
                </Link>
            </div >
        );
    }

    return (
        <>
            <div className={`DayBox  ${(_date === date) ? "active" : ""}`} valuedate={date} >
                <Link to={url}>
                    <div className={`text-center  DayBigFont`}>
                        <Moment tz={globalProps.timeZone} format="DD">
                            {date}
                        </Moment>
                    </div>
                    <div className={`text-center  DaySmallFont`} >
                        <Moment tz={globalProps.timeZone} format="MMMM">
                            {date}
                        </Moment>
                    </div>
                </Link>
            </div >
        </>
    )
}




